import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import s from './ModalFooter.module.css';

// TODO: мабуть краже все ж таки кидати через пропси щось по типу size але значення в кількості модулів css

const modalFooterVariants = cva(s.footer, {
  defaultVariants: {
    size: 'md',
  },
  variants: {
    size: {
      lg: s.s_lg,
      max: s.s_max,
      md: s.s_md,
      sm: s.s_sm,
      xl: s.s_xl,
    },
  },
});

type ModalFooterProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
  VariantProps<typeof modalFooterVariants>;

const ModalFooter: FC<ModalFooterProps> = ({ className, size, ...props }) => (
  <div className={modalFooterVariants({ className, size })} {...props} />
);

export { ModalFooter };
